var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRecipe = function SvgRecipe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.05 10.675c5.526-4.736 11.052-1.579 11.052-1.579v14.208c-6.907 0-11.051 1.579-11.051 1.579S11.907 23.304 5 23.304V9.096s5.525-3.157 11.05 1.579Z",
    stroke: "#3D3935"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.05 10.675v14.208",
    stroke: "#3D3935"
  })));
};
export default SvgRecipe;